// import Swiper JS
import Swiper, { Navigation, Pagination, Autoplay } from "swiper"
// import Swiper styles
import "swiper/css"
// import smoothscroll for Smooth Scroll behavior on Safari
import smoothscroll from "smoothscroll-polyfill"

// GSAP (GreenSock Animation Platform)
import gsap from "gsap"
import ScrollTrigger from "gsap/ScrollTrigger"

gsap.registerPlugin(ScrollTrigger)
window.gsap = gsap

// configure Swiper to use modules
Swiper.use([Navigation, Pagination, Autoplay])

document.addEventListener("DOMContentLoaded", () => {

    // init fslightbox
    require("fslightbox")
    // init smoothscroll
    smoothscroll.polyfill()

    // Custom progress bar and add header class on scroll

    window.addEventListener("scroll", progressBar)
    let header = document.querySelector("header")

    function progressBar() {
        let winScroll = document.body.scrollTop || document.documentElement.scrollTop
        let height = document.documentElement.scrollHeight - document.documentElement.clientHeight
        let scrolled = (winScroll / height) * 100
        document.getElementById("progressBar").style.width = scrolled + "%"
        if (window.pageYOffset < 1 && header.classList.contains("scroll")) {
            header.classList.remove("scroll");
            document.querySelectorAll('.header__nav a').forEach(el=>el.classList.remove('active'));
        }
        if (window.pageYOffset >= 150 && !header.classList.contains("scroll")) {
            header.classList.add("scroll")
        }
    }

    //Menu toggle

    const menuToggle = document.querySelector(".header__menu-toggle")
    const headerNav = document.querySelector("header nav")
    const menuLinks = document.querySelectorAll("header nav a")

    function navClick(e) {
        e.preventDefault();
        toggleMobileMenu();
        const sectionID = e.currentTarget.getAttribute("href");
        const section = document.querySelector(sectionID);
        const offset = section.offsetTop - header.offsetHeight;
        window.scrollTo({
            top: offset,
            behavior: 'smooth'
        });
    }


    function toggleMobileMenu() {
        menuToggle.classList.toggle("open")
        headerNav.classList.toggle("open")
        document.body.classList.toggle("overflow-hidden-mobile")
    }

    if (menuToggle && headerNav) {
        menuToggle.addEventListener("click", toggleMobileMenu)
    }

    if (menuLinks.length) {
        menuLinks.forEach(el => {
            el.addEventListener("click", navClick)
        })
    }


    // Impressum & Datenschutz opening on click

    let privacyLink = document.querySelectorAll(".imprint")

    const openBlock = (element) => {
        let block = document.querySelector(element.getAttribute("href"))
        let menuHeight_compensetion = document.querySelectorAll("header")[0].clientHeight

        if (!block.classList.contains("d-none")) {
            let anchorBlock = document.querySelector("footer")
            let elementPosition = anchorBlock.offsetTop
            let offsetPosition = elementPosition + anchorBlock.clientHeight - document.documentElement.clientHeight
            window.scrollTo({
                top: offsetPosition,
                behavior: "smooth"
            })
            setTimeout(() => {
                block.classList.add("d-none")
            }, 1000)
        } else {
            block.classList.remove("d-none")
            let anchorBlock = block
            let headerOffset = menuHeight_compensetion
            let elementPosition = anchorBlock.offsetTop
            let offsetPosition = elementPosition - headerOffset
            window.scrollTo({
                top: offsetPosition,
                behavior: "smooth"
            })
        }
    }

    privacyLink.forEach((link, index) => {
        link.addEventListener("click", (e) => {
            e.preventDefault()
            openBlock(e.target)
        })
    })

    // Get current year for copyright text

    let date = new Date()
    let year = date.getFullYear().toString()
    document.getElementById("year").innerText = year

    //Swiper Sliders

    const roomsSliders = document.querySelectorAll(".rooms-restaurant__item--slider > .swiper")

    if (roomsSliders.length) {
        roomsSliders.forEach((el) => {
            const btnNext = el.querySelector(".swiper-button-next")
            const btnPrev = el.querySelector(".swiper-button-prev")
            let swiper = new Swiper(el, {
                slidesPerView: 1,
                loop: true,
                speed: 700,
                spaceBetween: 30,
                autoplay: {
                    delay: 7000
                },
                navigation: {
                    nextEl: btnNext,
                    prevEl: btnPrev
                }
            })
        })
    }

    const bookingSlider = document.querySelector(".booking .swiper")

    if (bookingSlider) {
        const bookingSwiper = new Swiper(bookingSlider, {
            slidesPerView: 1,
            loop: true,
            speed: 700,
            spaceBetween: 30,
            pagination: {
                el: ".booking__slider--pagination",
                renderBullet: function (index, className) {
                    return `<span role="button" aria-label="Wechseln Sie zu Folie ${index + 1}" tabindex="0" class="${className}"></span>`;
                },
                clickable: true
            },
            navigation: {
                nextEl: ".booking__slider--next",
                prevEl: ".booking__slider--prev"
            },
            autoplay: {
                delay: 7000
            },
            breakpoints: {
                1024: {
                    direction: "vertical"
                }
            }
        })
    }

    // GSAP Animtions

    gsap.to(".hero .small-image", {
        y: 20,
        scrollTrigger: {
            trigger: ".hero",
            start: "top=-100 top",
            end: "bottom top",
            scrub: 1,
            toggleActions: "play none none reverse",
        }
    })

    gsap.to(".hero__image", {
        y: -30,
        scrollTrigger: {
            trigger: ".hero",
            start: "top=-100 top",
            end: "bottom top",
            scrub: 1.2,
            toggleActions: "play none none reverse",
        }
    })

    gsap.from(".about.first .about__icons-grid", {
        y:30,
        opacity: 0,
        scrollTrigger: {
            trigger: ".about.first .about__icons-grid",
            start: "50px bottom",
            toggleActions: "play none none reverse",
        }
    })

    gsap.from(".about.second .about__icons-grid", {
        y:30,
        opacity: 0,
        scrollTrigger: {
            trigger: ".about.second .about__icons-grid",
            start: "50px bottom",
            toggleActions: "play none none reverse",
        }
    })

    gsap.to(".about.first .background-image",{
        x: 70,
        scrollTrigger: {
            trigger: ".about.first .about__icons-grid",
            start: "top bottom",
            end: "bottom top",
            scrub: 1,
            toggleActions: "play none none reverse",
        }
    })

    gsap.to(".about.second .background-image",{
        x: 70,
        scrollTrigger: {
            trigger: ".about.second .about__icons-grid",
            start: "top bottom",
            end: "bottom top",
            scrub: 1,
            toggleActions: "play none none reverse",
        }
    })

    gsap.to(".gallery__grid.big .text-block", {
        rotationX: 0,
        duration: 0.4,
        scrollTrigger: {
            trigger: ".gallery__grid.big .text-block",
            start: "60% bottom",
            toggleActions: "play none none reverse",
        }
    })

    gsap.from(".gallery__grid.big .text-block p", {
        opacity: 0,
        duration: 0.2,
        scrollTrigger: {
            trigger: ".gallery__grid.big .text-block",
            start: "60% bottom",
            toggleActions: "play none none reverse",
        }
    })

    gsap.to(".gallery__grid.small .text-block", {
        rotationX: 0,
        duration: 0.4,
        scrollTrigger: {
            trigger: ".gallery__grid.small .text-block",
            start: "60% bottom",
            toggleActions: "play none none reverse",
        }
    })

    gsap.from(".gallery__grid.small .text-block p", {
        opacity: 0,
        duration: 0.2,
        scrollTrigger: {
            trigger: ".gallery__grid.small .text-block",
            start: "60% bottom",
            toggleActions: "play none none reverse",
        }
    })

    const navSections = document.querySelectorAll('.related-to-nav');

    navSections.forEach(el=>{
        ScrollTrigger.create({
            trigger: el,
            start: 'top 50%',
            end:'bottom 50%',
            onEnter: makeLinkActive,
            onEnterBack: makeLinkActive,
        });
    })

    function makeLinkActive(e) {
        document.querySelectorAll('.header__nav a').forEach(el=>el.classList.remove('active'));
        let href = '#' + e.trigger.id;
        document.querySelector(`.header__nav a[href='${href}']`).classList.add('active');
    }

})